import Axios from 'axios';

const client_id = process.env.REACT_APP_SENSEDIA_CLIENT_ID;
const credentialEncoded = process.env.REACT_APP_SENSEDIA_CREDENCIAL_ENCODED;

const GetSensediaGrantCode = async () => {

    try {
        let data = {
            "client_id": client_id,
            "redirect_uri": "https://d3jo8x240fpdvb.cloudfront.net"
        };

        let retorno = await Axios.post("https://api.energisa.io/oauth/grant-code", data);

        let dataRetorno = retorno.data.redirect_uri;

        let dataRetornoSplited = dataRetorno.split('?');
        let code = dataRetornoSplited[1].split('=');

        return code[1];
    } catch {}
}

const GetSensediaAccessToken = async (code) => {
    try {
        let RequestInstance = Axios.create({
            headers: {
                Authorization: `Basic ${credentialEncoded}`,
            }
        });

        let data = `grant_type=authorization_code&code=${code}`;

        let retorno = await RequestInstance.post("https://api.energisa.io/oauth/access-token", data);

        return retorno.data;
    } catch {}
}

const GetSensediaAuthorization = async () => {
    try {
        let sensediaToken = localStorage.getItem("sensedia_token");

        let token = "";

        if (sensediaToken === undefined || sensediaToken == null) {
            await GenerateAccessToken();
        } else {
            let oldtoken = JSON.parse(localStorage.getItem("sensedia_token"))

            const currentTimeAsMs = Date.now();
            const expireMilliseconds = new Date(oldtoken.expire).getTime();

            if (expireMilliseconds < currentTimeAsMs) {
                await GenerateAccessToken();
            }
        }

        token = JSON.parse(localStorage.getItem("sensedia_token")).access_token;

        return token;
    } catch (exception) {
        console.error(`Error: ${exception}`)
    }
}

const GenerateAccessToken = async () => {

    localStorage.removeItem('sensedia_token');

    let grantCode = await GetSensediaGrantCode();

    let accessToken = await GetSensediaAccessToken(grantCode);

    const currentTimeAsMs = Date.now();
    const adjustedTimeAsMs = currentTimeAsMs + (accessToken.expires_in * 1000);

    const adjustedDateObj = new Date(adjustedTimeAsMs);

    const data = {
        'client_id': client_id,
        'access_token': accessToken.access_token,
        'expire': adjustedDateObj
    }

    localStorage.setItem('sensedia_token', JSON.stringify(data))
}


export default GetSensediaAuthorization;